/* 🤖 this file was generated by svg-to-ts */
export const DfIconPencil16: {
  name: 'pencil-16';
  data: string;
} = {
  name: 'pencil-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m13.362 1.281 1.357 1.357a.96.96 0 0 1 0 1.358L13.7 5.013a.48.48 0 0 1-.679 0l-2.036-2.035a.48.48 0 0 1 0-.679l1.018-1.018a.96.96 0 0 1 1.358 0zm-3.054 2.375 2.036 2.036a.48.48 0 0 1 0 .679l-6.108 6.107a.48.48 0 0 1-.678 0l-2.036-2.036a.48.48 0 0 1 0-.678l6.107-6.108a.48.48 0 0 1 .679 0zm-9.272 10.68 1.193-2.89a.48.48 0 0 1 .783-.156l1.698 1.698a.48.48 0 0 1-.157.782l-2.89 1.194a.48.48 0 0 1-.627-.627z" fill-rule="evenodd"/></svg>`
};
